import { deserialize, serializable } from 'serializr';

export class IosRealDevice {
  @serializable
  id: number;
  @serializable
  wdaId: number;
  @serializable
  profileType: string;
  deserialize(input: any): this {
    return Object.assign(this, deserialize(IosRealDevice, input));
  }
}
